// ============================================================================
// Steadfastly - Badge Component
// ============================================================================
import React from 'react';

export function Badge({ children, color = "slate", size = "md", darkMode = false }) {
  const lightColors = { 
    slate: "bg-slate-100 text-slate-700 ring-slate-200/50", 
    emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200/50", 
    amber: "bg-amber-50 text-amber-700 ring-amber-200/50", 
    red: "bg-red-50 text-red-700 ring-red-200/50", 
    blue: "bg-blue-50 text-blue-700 ring-blue-200/50",
    indigo: "bg-indigo-50 text-indigo-700 ring-indigo-200/50",
    teal: "bg-teal-50 text-teal-700 ring-teal-200/50",
    rose: "bg-rose-50 text-rose-700 ring-rose-200/50",
    orange: "bg-orange-50 text-orange-700 ring-orange-200/50",
    cyan: "bg-cyan-50 text-cyan-700 ring-cyan-200/50",
    violet: "bg-violet-50 text-violet-700 ring-violet-200/50",
    lime: "bg-lime-50 text-lime-700 ring-lime-200/50",
    purple: "bg-purple-50 text-purple-700 ring-purple-200/50",
  };
  
  const darkColors = { 
    slate: "bg-slate-700/50 text-slate-300 ring-slate-600/50", 
    emerald: "bg-emerald-900/40 text-emerald-400 ring-emerald-700/50", 
    amber: "bg-amber-900/40 text-amber-400 ring-amber-700/50", 
    red: "bg-red-900/40 text-red-400 ring-red-700/50", 
    blue: "bg-blue-900/40 text-blue-400 ring-blue-700/50",
    indigo: "bg-indigo-900/40 text-indigo-400 ring-indigo-700/50",
    teal: "bg-teal-900/40 text-teal-400 ring-teal-700/50",
    rose: "bg-rose-900/40 text-rose-400 ring-rose-700/50",
    orange: "bg-orange-900/40 text-orange-400 ring-orange-700/50",
    cyan: "bg-cyan-900/40 text-cyan-400 ring-cyan-700/50",
    violet: "bg-violet-900/40 text-violet-400 ring-violet-700/50",
    lime: "bg-lime-900/40 text-lime-400 ring-lime-700/50",
    purple: "bg-purple-900/40 text-purple-400 ring-purple-700/50",
  };
  
  const colors = darkMode ? darkColors : lightColors;
  const sizes = { 
    sm: "px-1.5 py-0.5 text-[10px]", 
    md: "px-2.5 py-1 text-xs", 
    lg: "px-3 py-1 text-sm" 
  };
  
  return (
    <span className={`rounded-lg font-semibold ring-1 ring-inset transition-colors ${colors[color] || colors.slate} ${sizes[size] || sizes.md}`}>
      {children}
    </span>
  );
}

export default Badge;
